import React from "react";

const Icon = props => (
  <svg viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg" focusable="false" {...props}>
    <path fill="currentColor" d="M8.46 6.48A8.52 8.52 0 1 1 0 15a8.5 8.5 0 0 1 8.46-8.52ZM22 7c2.34 0 4.23 3.59 4.23 8 0 4.43-1.89 8-4.23 8s-4.23-3.59-4.23-8S19.64 7 22 7Zm6.54.84C29.33 7.82 30 11 30 15s-.67 7.18-1.49 7.18S27 19 27 15s.69-7.18 1.51-7.18Z" />
  </svg>
);

export default Icon;
